/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Link } from "react-router-dom";

const Header = ({toggleSidebar}) => {
  const [isOpenSearch, setIsOpenSearch] = useState(false)

  const handleOpenSearch = () => {
    setIsOpenSearch(!isOpenSearch)
  }

  const handleSignout = () => {
    localStorage.removeItem('signIn')
    localStorage.removeItem('projectId')
    localStorage.removeItem('clientId')
    localStorage.removeItem('OwnerId')
    localStorage.removeItem('documentId')
  }
  return (
    <header id="header" className="header fixed-top d-flex align-items-center">

      <div className="d-flex align-items-center justify-content-between">
        <a href="index.html" className="logo d-flex align-items-center">
          <img src="assets/img/logo.png" alt="" />
          <span className="d-none d-lg-block">RPR Software</span>
        </a>
        <i className="bi bi-list toggle-sidebar-btn" onClick={toggleSidebar}></i>
      </div>

      <div className={`search-bar ${isOpenSearch === false ? '' : 'search-bar-show'}`}>
        <form className="search-form d-flex align-items-center" method="POST" action="#">
          <input type="text" name="query" placeholder="Search" title="Enter search keyword" />
          <button type="button" title="Search"><i className="bi bi-search"></i></button>
        </form>
      </div>

      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">

          <li className="nav-item d-block d-lg-none">
            <a className="nav-link nav-icon search-bar-toggle " href="#">
              <i className="bi bi-search" onClick={handleOpenSearch}></i>
            </a>
          </li>
          <li className="nav-item dropdown pe-3">

            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
              <i className="bi bi-person-circle"></i>
            </a>

            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
              <li>
                <Link className="dropdown-item d-flex align-items-center" to='/login' onClick={handleSignout}>
                  <i className="bi bi-box-arrow-right"></i>
                  <span>Sign Out</span>
                </Link>
              </li>

            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
